module.exports = __webpack_public_path__ + "static/media/MemoryBoundaries.9b54b09e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lms/MemoryBoundaries.jpg
// module id = 416
// module chunks = 0